(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rinx-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-rinx-testimonials]');
    if (!root) return;

    const dataEl = root.querySelector('[data-rinx-testimonials-data]');
    const quoteEl = root.querySelector('[data-rinx-quote]');
    const authorEl = root.querySelector('[data-rinx-author]');
    const dots = root.querySelectorAll('[data-rinx-dot]');

    let items = [];
    try {
      items = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    if (!items.length) return;

    let current = 0;

    const show = (index) => {
      current = index;
      const item = items[index];
      if (!item) return;

      quoteEl.style.opacity = '0';
      authorEl.style.opacity = '0';

      window.setTimeout(() => {
        quoteEl.textContent = item.quote;
        authorEl.textContent = item.author;
        quoteEl.style.opacity = '1';
        authorEl.style.opacity = '1';
      }, 250);

      dots.forEach((dot) => {
        dot.classList.toggle('is-active', Number(dot.dataset.rinxDot) === index);
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => show(Number(dot.dataset.rinxDot)));
    });

    window.setInterval(() => {
      show((current + 1) % items.length);
    }, 6000);
  })();

  } catch(e) { console.error(e); }
})();
})();
